import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { useIntl } from 'react-intl';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types/common-types';
import { ExclusionRuleListParam, fetchExclusionRuleList } from 'src/app/modules/PulseLeads/network/exclusionRuleCrud';
import { ExclusionRule } from 'src/app/modules/PulseLeads/types/exclusion-rule-types';
import ExclusionRuleList from './components/ExclusionRuleList';

type ExclusionRuleListingPageProps = {} & ParamsProps;

const initialState: ExclusionRuleListParam = {
  name: '',
  limit: 5,
  page: 1,
};

const paramsInitiator = (initialParams?: Record<string, string>): ExclusionRuleListParam => {
  return initialParams
    ? {
        name: initialParams.name ?? '',
        limit: 5,
        page: 1,
      }
    : initialState;
};

export const exclusionRuleFilterKeys = ['name'];

const ExclusionRuleListingPage: FC<ExclusionRuleListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const dispatch = useDispatch();

  const [filterState, setFilterState] = useState<ExclusionRuleListParam>(paramsInitiator(initialParams));

  const [exclusionRuleList, setExclusionRuleList] = useState<PaginateList<ExclusionRule>>();
  const { isLoading, refreshData } = useDataProvider<PaginateList<ExclusionRule>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchExclusionRuleList(filterState, dispatch);
      } catch (err) {}
    },
    setExclusionRuleList,
    false,
  );

  return (
    <>
      <PruFilter
        title={Translation('pulseleads.exclusionRule.filter')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'name',
            initialValue: filterState.name,
            displayName: Translation('pulseleads.exclusionRule.common.name'),
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            name: data.name,
          })
        }
        fetchData={refreshData}
      />
      <ExclusionRuleList
        isLoading={isLoading}
        exclusionRuleList={exclusionRuleList}
        onRefresh={refreshData}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default ExclusionRuleListingPage;
